// $(function(){
//     //set banner height to ensure banner is height of viewport in safari (not the device screen height)
//     $(window).resize(function(){
//         $('section.home-banner').attr('style','');
//         $('section.home-banner').height($(window).height());
//     }).resize();    
// });